/**
 * Tâche 1319 (Eric 2026-06-30) — Retrouver un passage cité dans une synthèse.
 *
 * Copie VOLONTAIREMENT identique de `backend/core/synthesis_match.py` : le
 * serveur décide si une révision peut s'appliquer, et l'affichage décide sous
 * quel paragraphe la poser. Les deux doivent répondre la même chose, sinon une
 * révision s'applique sans jamais apparaître sous sa phrase. Un test de
 * sentinelle verrouille l'égalité des deux tables de remplacement.
 */

export const REMPLACEMENTS = {
  "’": "'", "‘": "'", "‛": "'", "´": "'", "ʼ": "'", "′": "'",
  "“": '"', "”": '"', "«": '"', "»": '"', "„": '"', "‟": '"', "″": '"',
  "–": "-", "—": "-", "‒": "-", "―": "-", "‐": "-", "‑": "-",
  "…": ".",
};

// En dessous de cette longueur, on exige la correspondance COMPLÈTE.
export const LONGUEUR_ANCRE = 60;

/** Forme pliée : minuscules, ponctuation unifiée, espaces et points écrasés.
 *
 *  Les espaces typographiques françaises sont retirées (celle qui suit un
 *  guillemet ouvrant, celle qui précède « : ; ! ? % » ou un guillemet
 *  fermant) : le vérificateur les recopie une fois sur deux, et « 18 % »
 *  contre « 18% » suffisait à faire échouer la comparaison.
 */
export const plier = (texte) => {
  const avantSansEspace = new Set([":", ";", "!", "?", "%", '"']);
  const marqueursMarkdown = new Set(["*", "_", "`"]);
  const out = [];
  let precedent = "";
  for (const brut of String(texte || "")) {
    // Le corps est du Markdown ; le vérificateur cite la phrase telle qu'elle
    // se LIT, sans les étoiles du gras. Un seul mot en gras au milieu d'une
    // phrase la rendait introuvable.
    if (marqueursMarkdown.has(brut)) continue;
    let car = REMPLACEMENTS[brut] || brut;
    if (/\s/.test(car)) car = " ";
    car = car.toLowerCase();
    if (car === " " && (precedent === " " || precedent === '"')) continue;
    if (car === "." && precedent === ".") continue;
    if (avantSansEspace.has(car) && precedent === " ") {
      out.pop();
      precedent = out.length ? out[out.length - 1] : "";
    }
    out.push(car);
    precedent = car;
  }
  return out.join("");
};

/**
 * Vrai si le paragraphe contient le passage, aux écarts de recopie près
 * (apostrophe typographique, guillemets, espace insécable, « … » / « ... »).
 */
export const contientPassage = (paragraphe, extrait) => {
  const aiguille = plier(extrait).trim();
  if (!aiguille) return false;
  const botte = plier(paragraphe);
  if (botte.includes(aiguille)) return true;
  // Même repli d'ancrage que le serveur : un extrait tronqué à 500 caractères
  // ou dont la fin a été reformulée garde un début verbatim.
  if (aiguille.length > LONGUEUR_ANCRE) {
    return botte.includes(aiguille.slice(0, LONGUEUR_ANCRE));
  }
  return false;
};

export default contientPassage;
